import "./ReportIssues.scss";
import React, { useState, useRef } from "react";
import {
    IonContent,
    IonPage,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonList,
    IonItem,
    IonLabel,
    IonSelect,
    IonSelectOption,
    IonTextarea,
    IonToggle,
    IonButton,
    IonFooter,
    IonLoading,
} from "@ionic/react";
import { useHistory } from "react-router-dom";
import { emailSendTechnicalSupport } from "../../api/help";
import { useTracked } from "../../state";
import { ShowToastSuccessMessage } from "../../utils/helpers/ToastMessage";

const options = {
    cssClass: 'pop-over-interface'
};

const ReportIssues: React.FC = React.memo(() => {
    const history = useHistory();
    const [state] = useTracked();
    const hiddenFileInput = useRef<any>(null);
    const [selectedImage, setSelectedImage] = useState<any>(null);
    const [selectedOption, setSelectedOption] = useState<any>(null);
    const [textDetail, setTextDetail] = useState<any>(null);
    const [includeEmail, setIncludeEmail] = useState<boolean>(true);
    const [isLoading, setIsLoading] = React.useState(false);

    const handleClickUpload = (event: any) => {
        hiddenFileInput.current.click();
      };

    const handleChange = async(event: any) => {
        const fileUploaded = event.target.files[0];
        setSelectedImage(fileUploaded);
    };

    const handleRemoveImage = () => {
        setSelectedImage(null);
    }

    const handleEmailSend = async() => {
        setIsLoading(true);
        let payload: any = {
            from: state.user.email,
            to: "support@abaxxexchange.atlassian.net",
            subject: `Report Issue - ${selectedOption}`,
            text: textDetail,
        }

        if(includeEmail) {
            payload.subject = `Report Issue - ${selectedOption} (${state.user.email})`;
        }
    
        await emailSendTechnicalSupport(payload);
        setIsLoading(false);
        setSelectedImage(null);
        setSelectedOption(null);
        setTextDetail(null);
        ShowToastSuccessMessage("Report has been sent.");
    };

    return (
        <IonPage className="report-page">
            <IonHeader className="ion-no-border" mode="ios">
                <IonToolbar mode="ios">
                    <IonButtons slot="start" style={{marginLeft: "8px"}}>
                        <IonBackButton defaultHref="/help" text="" />
                    </IonButtons>

                    <IonTitle>Having trouble?</IonTitle>

                </IonToolbar>
            </IonHeader>
            <IonContent>
            <IonLoading isOpen={isLoading} />
            <IonList lines="none" mode="ios">
                <IonItem className="input-item-list" detail={false}>
                    <IonLabel position="stacked">What are you trying to do?</IonLabel>
                    <IonSelect
                        placeholder="Select an option"
                        interface="popover"
                        interfaceOptions={options}
                        value={selectedOption}
                        onIonChange={(e)=> {
                            setSelectedOption(e.detail.value);
                        }}>
                        <IonSelectOption value="Add or sign in to an account">Add or sign in to an account</IonSelectOption>
                        <IonSelectOption value="Archiving or adding">Archiving or adding</IonSelectOption>
                        <IonSelectOption value="Synchronization and autofill of passwords">Synchronization and autofill of passwords</IonSelectOption>
                        <IonSelectOption value="Account management">Account management</IonSelectOption>
                        <IonSelectOption value="Other">Other</IonSelectOption>
                    </IonSelect>
                </IonItem>
                <IonItem className="input-item-list" detail={false}>
                    <IonLabel position="stacked">Describe the issue you are facing</IonLabel>
                    <IonTextarea 
                        placeholder="Please don’t include your name, phone number, or other personal information."
                        rows={6}
                        value={textDetail} 
                        onIonChange={(e)=> {
                            setTextDetail(e.detail.value);
                        }}>
                    </IonTextarea>
                </IonItem>
                <div className="container-contact-email">
                    <div className="contact-email">
                        <IonItem className="input-item-list" detail={false}>
                            <IonLabel>Include contact email address</IonLabel>
                            <IonToggle
                                slot="end" 
                                name="includeEmail" 
                                color="success"
                                onClick={(e: any)=>{
                                    setIncludeEmail(e.target.checked);
                                }} 
                                checked={includeEmail}></IonToggle>
                        </IonItem>
                        <hr />
                        <IonItem className="input-item-list" detail={false}>
                            <IonLabel>{state.user.email}</IonLabel>
                        </IonItem>
                    </div>
                    <IonLabel>
                        We will contact you if we need more details.
                    </IonLabel>
                </div>
                <div className="image-upload-content">
                    <IonItem className="image-item-list" detail={false}>
                        <IonLabel>Add a screenshot</IonLabel>
                        {selectedImage && 
                        <IonButton 
                            slot="end" 
                            size="small" 
                            style={{fontSize: "16px", color: "#eb445a"}}
                            onClick={handleRemoveImage}>Remove</IonButton>}
                        <IonButton 
                            slot="end" 
                            size="small" 
                            style={{fontSize: "16px"}}
                            onClick={handleClickUpload}>{selectedImage ? "Edit" : "Add"}</IonButton>
                        <input
                            type="file"
                            ref={hiddenFileInput}
                            onChange={handleChange}
                            accept="image/*"
                            style={{display: 'none'}}
                        />
                    </IonItem>
                    {selectedImage &&
                    <IonItem className="image-item-list" detail={false} style={{marginTop: "-25px"}}>
                        <div className="image-upload-container">
                            <hr />
                            <img src={URL.createObjectURL(selectedImage)} alt="imageFile"/>
                        </div>
                    </IonItem>}
                    <IonLabel>
                        Your feedback will be used to improve Verifier’s products and services. 
                        By including your email address, you agree that Verifier can email you about your feedback. 
                    </IonLabel>
                    <br />
                    <IonLabel 
                        color="danger" 
                        style={{textDecoration: "underline"}}
                        onClick={() => {
                            history.push(`/privacy-policy`);
                        }}>
                        Verifier Privacy Statement 
                    </IonLabel>
                </div>
            </IonList>
            </IonContent>
            <IonFooter>
                <IonButton 
                    color={selectedOption && textDetail ? "danger" : "light"} 
                    expand="block"
                    onClick={handleEmailSend} 
                    disabled={selectedOption && textDetail ? false : true}>Send</IonButton>
            </IonFooter>
        </IonPage>
    );
});

export default ReportIssues;